import React from "react";
import { AppLink } from "../../../components/ui/link";
import type { MainAppPageProps, MarketingFaq } from "../types";

type FaqPageProps = Pick<MainAppPageProps, "routes"> & {
  faqs?: MarketingFaq[];
};

const Q_CLASS = "mb-2 font-display text-base font-semibold text-foreground";
const A_CLASS = "mb-6 text-sm leading-relaxed text-muted-foreground last:mb-0";

const FALLBACK_FAQS: MarketingFaq[] = [];

export const FaqPage: React.FC<FaqPageProps> = ({ routes, faqs }) => {
  const entries = faqs && faqs.length > 0 ? faqs : FALLBACK_FAQS;

  return (
    <article className="mx-auto max-w-3xl">
      <h1 className="mb-8 font-display text-2xl font-semibold tracking-tight text-foreground">
        Frequently Asked Questions
      </h1>

      {entries.length > 0 ? (
        <div className="space-y-6">
          {entries.map((entry) => (
            <div key={entry.id}>
              <p className={Q_CLASS}>{entry.question}</p>
              <p
                className={A_CLASS}
                dangerouslySetInnerHTML={{ __html: entry.answerHtml }}
              />
            </div>
          ))}
        </div>
      ) : (
        <p className={A_CLASS}>
          We're updating our FAQ. In the meantime, see our{" "}
          <AppLink to={routes.terms} variant="premium">
            Terms of Service
          </AppLink>{" "}
          and{" "}
          <AppLink to={routes.privacy} variant="premium">
            Privacy Policy
          </AppLink>
          .
        </p>
      )}
    </article>
  );
};
